
const isPrerender = navigator.userAgent.indexOf("RusEtfsPrerender") !== -1;

export const LoadingComponent = () => {
	if (isPrerender)
		return null;

	return (
		<div className="loader">
			<img className="loader-image"></img>
		</div>
	);
}